import gql from 'graphql-tag';
import memberFragment from './fragments/memberFragment';

export default gql`
  ${memberFragment}

  mutation updateUser(
    $firstName: String
    $surname: String
    $email: String
    $phoneNumber: String
    $oldPassword: String
    $password: String
    $confirmPassword: String
    $contactPermission: Boolean
    $termsAndPrivacy: Boolean
    $noFacebook: Boolean
    $noInstagram: Boolean
    $siteId: Int
    $cityId: Int
    $promoCode: String
    $suburbIds: [Int]
  ) {
    updateUser(
      siteId: $siteId
      cityId: $cityId
      suburbIds: $suburbIds
      userInput: {
        firstName: $firstName
        surname: $surname
        email: $email
        phoneNumber: $phoneNumber
        oldPassword: $oldPassword
        password: $password
        confirmPassword: $confirmPassword
        contactPermission: $contactPermission
        termsAndPrivacy: $termsAndPrivacy
        noFacebook: $noFacebook
        noInstagram: $noInstagram
        promoCode: $promoCode
      }
    ) {
      ...memberFragment
    }
  }
`;
